import { render, staticRenderFns } from "./understand-product.vue?vue&type=template&id=1cc19f50&"
import script from "./understand-product.vue?vue&type=script&lang=js&"
export * from "./understand-product.vue?vue&type=script&lang=js&"
import style0 from "./understand-product.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports